//Manage User - For Admin (Edit Option)

import React, { useState, useEffect, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Paper,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  IconButton,
  Typography,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Radio, RadioGroup,
  Snackbar, Alert, Autocomplete
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RefreshIcon from "@mui/icons-material/Refresh";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DataTable = () => {
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    First_Name: "",
    Mobile_Number: "",
    Member_ID: "",
    Payment_Status: "",
    ID_Card: "",
    Role: "",
  });

  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editedUser, setEditedUser] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMobile, setSelectedMobile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const districts = [
    "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
    "Dindigul", "Erode", "Kallakurichi", "Kancheepuram", "Kanyakumari", "Karur", "Karaikal", "Krishnagiri",
    "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal", "Nilgiris", "Perambalur", "Pudukkottai",
    "Ramanathapuram", "Ranipet", "Salem", "Sivaganga", "Tenkasi", "Thanjavur", "Theni", "Thoothukudi",
    "Thiruchirappalli", "Tirunelveli", "Tirupathur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur",
    "Vellore", "Viluppuram", "Virudhunagar", "Other"
  ];

  const states = ["Tamil Nadu", "Other"];

  const starOptions = [
    "Ashwini", "Bharani", "Krithikai", "Rohini", "Mirgasheersham", "Thiruvaathirai",
    "Punarpoosam", "Poosam", "Aayilyam", "Pooram", "Uthiram", "Hastham", "Chithirai",
    "Swaathi", "Visaakam", "Anusham", "Kettai", "Moolam", "Pooraadam", "Uthiraadam",
    "Thiruvonam", "Avittam", "Chathayam/Sadayam", "Poorattathi", "Uthirattathi",
    "Revathi", "Makam"
  ];

  const raasiOptions = [
    "Mesham", "Risabham", "Mithunam", "Kadagam", "Simmam", "Kanni",
    "Thulam", "Viruchigam", "Dhanushu", "Magaram", "Kumbham", "Meenam"
  ];

  const handleOpenDialog = (mobileNumber) => {
    setSelectedMobile(mobileNumber);
    setOpenDialog(true);
  };


  const navigate = useNavigate();
  useEffect(() => {
    fetchData();
  }, []);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedMobile(null);
  };



  const [formData2, setFormData2] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    dob: "",
    city: "",
    district: "",
    state: "",
    pincode: "",
    identityProofType: "",
    identityProofNumber: "",
    panCard: "",
    panCardNumber: "",
    email: "",
    occupation: "",
    address: "",
    familyDetails: "",
    maritalStatus: "",
    star: "",
    userType: "",
    raasi: "",
    kootram: "",
    kuladeivam: "",
    paymentStatus: "",
  });

  useEffect(() => {


    setFormData2({
      firstName: editedUser ? editedUser.First_Name : "",
      lastName: editedUser ? editedUser.Last_Name : "",
      mobile: editedUser ? editedUser.Mobile_Number : "",
      dob: editedUser ? editedUser.DOB : "",
      city: editedUser ? editedUser.City : "",
      district: editedUser ? editedUser.District : "",
      state: editedUser ? editedUser.State : "",
      pincode: editedUser ? editedUser.Pincode : "",
      identityProofType: editedUser ? editedUser.ID_Proof_Type : "",
      identityProofNumber: editedUser ? editedUser.ID_Proof_Number : "",
      panCard: editedUser ? editedUser.Pan_Card : "",
      panCardNumber: editedUser ? editedUser.Pan_Number : "",
      email: editedUser ? editedUser.Email : "",
      occupation: editedUser ? editedUser.Occupation : "",
      address: editedUser ? editedUser.Address : "",
      familyDetails: editedUser ? editedUser.Family_Details : "",
      maritalStatus: editedUser ? editedUser.Marital_Status : "",
      star: editedUser ? editedUser.Star : "",
      userType: editedUser ? editedUser.User_Type : "",
      raasi: editedUser ? editedUser.Raasi : "",
      kootram: editedUser ? editedUser.Kootram : "",
      kuladeivam: editedUser ? editedUser.Kuladeivam : "",
      paymentStatus: editedUser ? editedUser.Payment_Status : "",

    });
  }, [editedUser]);


  const validateForm = () => {
    let newErrors = {};

    // Check if DOB exists
    if (!editedUser?.DOB?.trim()) {
      newErrors.DOB = "Date of Birth is required";
    } else {
      const selectedDate = dayjs(editedUser.DOB, "YYYY-MM-DD", true);
      const today = dayjs().startOf("day");
      const minDate = dayjs("1900-01-01");
      const minAllowedDate = dayjs().subtract(18, "year").startOf("day");

      if (selectedDate >= today) {
        newErrors.DOB = "Date of Birth must be in the past";
      } else if (selectedDate < minDate) {
        newErrors.DOB = "Date of Birth must be after 01-01-1900";
      } else if (selectedDate > minAllowedDate) {
        newErrors.DOB = "Minimum age required to register is 18 years.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };





  const handleSubmit = async (e) => {


    e.preventDefault();
    setIsSubmitted(true);
    if (!validateForm()) return;

    const dobObj = editedUser?.DOB ? dayjs(editedUser.DOB) : null;
    const formattedDob = dobObj?.isValid() ? dobObj.format("YYYY-MM-DD") : "";

    if (!dobObj || !dobObj.isValid() || dobObj.isBefore(dayjs("1900-01-01"))) {
      setSnackbarMessage("Invalid Date of Birth! Must be after 01-01-1900.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }


    const requestBody = {
      method: "patch",
      body: JSON.stringify(editedUser),
      ...editedUser,
      ...formData2,
      dob: formattedDob,
      paymentStatus: editedUser.Payment_Status,

    };

    console.log("Sending Data:", requestBody);


    try {
      setIsLoading(true);
      const response = await fetch(
        API_BASE_URL,
        {
          method: "POST",
          mode: "cors",
          // headers: {
          //   "Content-Type": "application/json",
          // },
          body: JSON.stringify(requestBody),
        }
      );

      const result = await response.json();

      if (result.status === "error") {

        setSnackbarMessage(result.message);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setIsLoading(false);
        return;
      }


      console.log("Data sent successfully:", requestBody);


      setOpenEditModal(false);
      setSelectedUser(null);
      setEditedUser(null);
      setIsLoading(false);

      // Show success Snackbar
      setSnackbarMessage("Member updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      // Refresh API data
      await handleRefresh();

      // Close dialog after successful submission
    } catch (error) {
      console.error("Error sending data:", error);
      setSnackbarMessage("Something went wrong!");
      setSnackbarOpen(true);
      setIsLoading(false);


      alert("Failed to send data");

      // Show error Snackbar
      setSnackbarMessage("Failed to update member!");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const fetchData = async () => {
    const mobile = localStorage.getItem("mobile");
    const userType = localStorage.getItem("user_type");

    if (!mobile || !userType) {
      console.error("Mobile number or user type not found in localStorage");
      setIsLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}?action=manageuser&mobile=${mobile}&usertype=${userType}`);
      const result = await response.json();

      console.log("API Response after refresh", result);

      if (result.status === "success" && Array.isArray(result.data)) {
        setData(result.data);
      } else {
        console.error("Unexpected API response structure", result);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleResponse = (response) => {
    if (response.status === "error") {
      setSnackbarMessage(response.message);
      setSnackbarSeverity("error");
    } else {
      setSnackbarMessage(response.message);
      setSnackbarSeverity("success"); // Ensure success messages appear in green
    }
    setSnackbarOpen(true);
  };


  const filteredData = useMemo(() => data.filter((row) =>
    Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      let value = row[key] ? row[key].toString().toLowerCase().trim() : "";
      let filterValue = filters[key].toLowerCase().trim();

      // Normalize values (replace underscores with spaces)
      value = value.replace(/_/g, " ");

      if (key === "Payment_Status" || key === "ID_Card") {
        // Ensure exact match instead of checking prefix
        return value === filterValue;
      }

      return value.includes(filterValue);
    })
  ),
    [data, filters]
  );




  const handleCreate = () => {
    navigate("/userprofile");
    window.scrollTo(0, 0);
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditedUser({ ...user });
    // Copy user data to editable state
    setOpenEditModal(true);


  };

  const handlePaymentStatusChange = (status) => {
    console.log("Payment status changed:", status);
    setEditedUser((prev) => ({ ...prev, Payment_Status: status }));

    // Update the data in the table
    setData((prevData) =>
      prevData.map((row) =>
        // Match by ID
        row.Member_ID === editedUser?.Member_ID
          // Update the Payment field
          ? { ...row, paymentStatus: status }
          : row
      )
    );
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };


  const handleRefresh = async () => {
    setFilters({
      First_Name: "",
      Mobile_Number: "",
      Member_ID: "",
      Payment_Status: "",
      ID_Card: "",
      Role: "",
    });

    await fetchData();
  };

  const handleClose = () => {
    setOpenEditModal(false);
    setSelectedUser(null);
    setEditedUser(null);
    setOpenDialog(false);
  };

  const handleSaveEdit = () => {
    if (!editedUser) return;

    // handleSubmit();
    setData((prevData) =>
      prevData.map((item) => (item.Member_ID === editedUser.Member_ID ? editedUser : item))
    );


  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevents page reload
      console.log("Enter key pressed"); // Debugging log
      handleSubmit(e);
    }
  };




  return (
    <div style={{ padding: 20 }} sx={{ "& .MuiPaper-root": { backgroundColor: "#f8f9e9 !important" } }}>
      <Typography variant="h5" sx={{ fontWeight: "500", color: "#2A289C", textAlign: "center", fontSize: "32px" }} gutterBottom>
        Manage Users
      </Typography>



      <div style={{ display: "flex", gap: 10, marginBottom: 10, flexWrap: "wrap" }} sx={{ "& .MuiPaper-root": { backgroundColor: "#f8f9e9 !important" } }} >
        <IconButton color="primary" onClick={handleRefresh}>
          <RefreshIcon />
        </IconButton>
        <Button variant="contained" color="success" onClick={handleCreate} sx={{ borderRadius: "20px" }}>
          Create
        </Button>
        <TextField name="First_Name" label="First Name" variant="outlined" size="small" value={filters.First_Name} onChange={handleFilterChange} sx={{ flex: '1 1 230px', minWidth: 230 }} />
        <TextField name="Mobile_Number" label="Mobile Number" variant="outlined" size="small" value={filters.Mobile_Number} onChange={handleFilterChange} sx={{ flex: '1 1 230px', minWidth: 230 }}/>
        <TextField name="Member_ID" label="Member ID" variant="outlined" size="small" value={filters.Member_ID} onChange={handleFilterChange} sx={{ flex: '1 1 230px', minWidth: 230 }} />
        <FormControl variant="outlined" size="small" sx={{ flex: '1 1 230px', minWidth: 230 }}>
          <InputLabel>Payment Status</InputLabel>
          <Select
            name="Payment_Status"
            value={filters.Payment_Status}
            onChange={handleFilterChange}
            label="Payment Status"
            sx={{ backgroundColor: "#f8f9e9" }}
            MenuProps={{
              PaperProps: {
                sx: {
                  backgroundColor: "#f8f9e9",
                },
              },
            }}
          >

            <MenuItem value="Paid">Paid</MenuItem>
            <MenuItem value="Unpaid">Unpaid</MenuItem>
            <MenuItem value="Failed">Failed</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" size="small" sx={{ flex: '1 1 230px', minWidth: 230 }}>
          <InputLabel>ID Card Status </InputLabel>
          <Select
            name="ID_Card"
            value={filters.ID_Card}
            onChange={handleFilterChange}
            label="ID Card Status"
            sx={{ backgroundColor: "#f8f9e9" }}
            MenuProps={{
              PaperProps: {
                sx: {
                  backgroundColor: "#f8f9e9",
                },
              },
            }}
          >

            <MenuItem value="generated">Generated</MenuItem>
            <MenuItem value="not generated">Not Generated</MenuItem>
          </Select>
        </FormControl>

      </div>

      <TableContainer component={Paper} sx={{
        backgroundColor: "#f8f9e9",
      }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#FFD700" }}>
            <TableRow>
              <TableCell><b>First Name</b></TableCell>
              <TableCell><b>Mobile Number</b></TableCell>
              <TableCell><b>Member ID</b></TableCell>
              <TableCell><b>Payment</b></TableCell>
              <TableCell><b>ID Card</b></TableCell>
              <TableCell><b>Actions</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress color="success" />
                </TableCell>
              </TableRow>
            ) : filteredData.length > 0 ? (
              filteredData.map((row) => (
                <TableRow key={row.Mobile_Number}>
                  <TableCell>{row.First_Name || "N/A"}</TableCell>
                  <TableCell>{row.Mobile_Number || "N/A"}</TableCell>
                  <TableCell>{row.Member_ID || "N/A"}</TableCell>
                  <TableCell>{row.Payment_Status || "Unpaid"}</TableCell>
                  <TableCell>{row.ID_Card || "Not Generated"}</TableCell>
                  <TableCell>
                    <IconButton color="primary" onClick={() => handleEdit(row)}>
                      <EditIcon />
                    </IconButton>
                    <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}  >
                      <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
                        {snackbarMessage}
                      </Alert>
                    </Snackbar>


                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No records found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Edit User Popup Modal */}
      <Dialog open={openEditModal} onClose={handleClose} fullWidth maxWidth="sm" sx={{ "& .MuiPaper-root": { backgroundColor: "#f8f9e9 !important" } }} >

        <DialogTitle>Edit User Profile</DialogTitle>
        <DialogContent sx={{ "& .MuiPaper-root": { backgroundColor: "#f8f9e9 !important" } }} >
          <Grid container spacing={2} onKeyDown={handleKeyDown} tabIndex="0">
            <Grid item xs={6} >
              <TextField fullWidth size="small" margin="dense" label="First Name" name="First_Name" value={editedUser?.First_Name || ""}
                onChange={(e) => setEditedUser({ ...editedUser, First_Name: e.target.value.replace(/[^A-Za-z ]/g, ""), })}
                inputProps={{ maxLength: 25, pattern: "[A-Za-z ]*" }}
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" margin="dense" label="Last Name" name="Last_Name" value={editedUser?.Last_Name || ""}
                onChange={(e) => setEditedUser({ ...editedUser, Last_Name: e.target.value.replace(/[^A-Za-z ]/g, ""), })}
                inputProps={{ maxLength: 25, pattern: "[A-Za-z ]*" }}
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid item xs={6} mt={1}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Date of Birth"
                  format="DD-MM-YYYY"
                  value={editedUser?.DOB ? dayjs(editedUser.DOB, "YYYY-MM-DD") : null}
                  onChange={(date) =>
                    setEditedUser({ ...editedUser, DOB: date ? date.format("YYYY-MM-DD") : "" })
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      error: !!errors?.DOB,
                      helperText: errors?.DOB || "",
                      required: true,
                    },
                    popper: {
                      sx: {
                        '& .MuiPaper-root': {
                          backgroundColor: '#f8f9e9',
                        },
                      },
                    },
                  }}
                  disableFuture
                  maxDate={dayjs().subtract(18, "year")}
                  minDate={dayjs("1900-01-01")}
                />
              </LocalizationProvider>

            </Grid>


            <Grid item xs={6}>
              <TextField fullWidth size="small" disabled type="text" margin="dense" label="Mobile Number" value={editedUser?.Mobile_Number || ""}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setEditedUser({ ...editedUser, Mobile_Number: inputValue });
                }}
                inputProps={{ maxLength: 10, pattern: "[0-9]{10}" }}
                error={editedUser?.Mobile_Number?.length > 0 && editedUser?.Mobile_Number.length < 10}
                helperText={
                  editedUser?.Mobile_Number?.length > 0 && editedUser?.Mobile_Number.length < 10
                    ? "Mobile Number must be exactly 10 digits"
                    : ""
                }
              />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" margin="dense" label="City" value={editedUser?.City || ""}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allows only letters & spaces
                  setEditedUser({ ...editedUser, City: inputValue });
                }}
                inputProps={{ pattern: "[A-Za-z ]*" }} // Ensures only alphabets & spaces
                error={!!editedUser?.City && /[^a-zA-Z\s]/.test(editedUser.City)}
                helperText={
                  !!editedUser?.City && /[^a-zA-Z\s]/.test(editedUser.City)
                    ? "Please provide a validate City Name"
                    : ""
                }
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid item xs={6} style={{ marginTop: 8 }}>
              <Autocomplete
                options={districts}
                value={editedUser?.District || ""}
                onChange={(event, newValue) => {
                  setEditedUser({ ...editedUser, District: newValue });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="District"
                    variant="outlined"
                    size="small"

                    sx={{
                      backgroundColor: "#f8f9e9",
                      "& .MuiInputBase-input": {
                        caretColor: "transparent",
                        cursor: "pointer",
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        backgroundColor: "#f8f9e9",
                        px: 1,
                        transform: "translate(14px, -6px) scale(0.75)"
                      }
                    }}
                  />
                )}
                disableClearable
                fullWidth
                autoHighlight
                PaperComponent={(props) => (
                  <Paper
                    {...props}
                    sx={{
                      backgroundColor: "#f8f9e9",
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} style={{ marginTop: 8 }}>
              <Autocomplete
                options={states}
                value={editedUser?.State || ""}
                onChange={(event, newValue) => {
                  setEditedUser({ ...editedUser, State: newValue });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="State"
                    variant="outlined"
                    size="small"

                    sx={{
                      backgroundColor: "f8f9e9",
                      "& .MuiInputBase-input": {
                        caretColor: "transparent",
                        cursor: "pointer",
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      sx: {
                        backgroundColor: "#f8f9e9",
                        px: 1,
                        transform: "translate(14px, -6px) scale(0.75)"
                      }
                    }}
                  />
                )}
                disableClearable
                fullWidth
                autoHighlight

                PaperComponent={(props) => (
                  <Paper
                    {...props}
                    sx={{
                      backgroundColor: "#f8f9e9",
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" type="text" margin="dense" label="Pincode" value={editedUser?.Pincode || ""}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/\D/g, "").slice(0, 6);
                  setEditedUser({ ...editedUser, Pincode: inputValue });
                }}
                inputProps={{ maxLength: 6, pattern: "[0-9]{6}" }}
                error={!!editedUser?.Pincode && editedUser?.Pincode.length < 6}
                helperText={editedUser?.Pincode?.length > 0 && editedUser?.Pincode.length < 6
                  ? "Pincode must be exactly 6 digits"
                  : ""
                }
                onKeyDown={handleKeyDown}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField fullWidth size="small" disabled type="text" margin="dense" label="Member ID" value={editedUser?.Member_ID || ""}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^A-Za-z0-9 ,]/g, ""); // Allows only alphabets, numbers, spaces, and commas
                  setEditedUser({ ...editedUser, Member_ID: inputValue });
                }}
                inputProps={{ pattern: "[A-Za-z0-9 ,]*" }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField fullWidth size="small" type="text" margin="dense" label="Occupation" name="Occupation" value={editedUser?.Occupation || ""}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^A-Za-z ]/g, "");
                  setEditedUser({ ...editedUser, Occupation: inputValue });
                }}
                inputProps={{ maxLength: 25, pattern: "[A-Za-z ]*" }}
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth size="small" margin="dense" label="Address" value={editedUser?.Address || ""}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^A-Za-z0-9 ,|\/@#&()-._]/g, "");
                  setEditedUser({ ...editedUser, Address: inputValue });
                }}
                inputProps={{ pattern: "[A-Za-z0-9 ,|/@#&()-._]*" }}
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" margin="dense" label="Email ID" value={editedUser?.Email || ""}
                onChange={(e) => {
                  const emailValue = e.target.value;
                  setEditedUser({ ...editedUser, Email: emailValue });
                }}
                error={!!editedUser?.Email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(editedUser?.Email)}
                helperText={
                  !!editedUser?.Email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(editedUser?.Email)
                    ? "Enter a valid email address (e.g., example@domain.com)"
                    : ""
                }
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" margin="dense" label="Family Details" placeholder="Number of Family Members" value={editedUser?.Family_Details || ""}
                onChange={(e) =>
                  setEditedUser({
                    ...editedUser,
                    Family_Details: e.target.value.replace(/[^A-Za-z0-9, ]/g, "") // Allows letters, numbers, commas, and spaces
                  })
                }
                inputProps={{ maxLength: 100 }}
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={starOptions}
                value={editedUser?.Star || null}
                onChange={(event, newValue) => {
                  setEditedUser({ ...editedUser, Star: newValue || "" });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Star"
                    size="small"
                    margin="dense"
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      backgroundColor: "#f8f9e9",
                    }}
                  />
                )}
                fullWidth
                slotProps={{
                  paper: {
                    sx: {
                      backgroundColor: "#f8f9e9",
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                options={raasiOptions}
                value={editedUser?.Raasi || null}
                onChange={(event, newValue) => {
                  setEditedUser({ ...editedUser, Raasi: newValue || "" });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Raasi"
                    size="small"
                    margin="dense"
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      backgroundColor: "#f8f9e9",
                    }}
                  />
                )}
                fullWidth
                slotProps={{
                  paper: {
                    sx: {
                      backgroundColor: "#f8f9e9",
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField fullWidth size="small" margin="dense" label="Gothram" value={editedUser?.Kootram || ""}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^A-Za-z ]/g, "");
                  setEditedUser({ ...editedUser, Kootram: inputValue });
                }}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" margin="dense" label="Kuladeivam" value={editedUser?.Kuladeivam || ""}
                onChange={(e) =>
                  setEditedUser({
                    ...editedUser,
                    Kuladeivam: e.target.value.replace(/[^A-Za-z ]/g, ""),
                  })
                }
                inputProps={{ maxLength: 50 }}
                onKeyDown={handleKeyDown}
              />
            </Grid>

            <Grid item xs={6}
            >
              <FormControl fullWidth disabled size="small" margin="dense" >
                <InputLabel shrink sx={{ backgroundColor: "#f8f9e9", px: 1, transform: "translate(14px, -6px) scale(0.75)", }}
                >Payment Status</InputLabel>
                <Select
                  value={editedUser?.Payment_Status || ""}
                  onChange={(e) => handlePaymentStatusChange(e.target.value)}
                >
                  <MenuItem value="Paid">Paid</MenuItem>
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Failed">Failed</MenuItem>

                </Select>
              </FormControl>
            </Grid>






            {/* ID Proof Label & Radio Buttons in One Row */}
            <Grid item xs={12} sm={6} >

              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend" sx={{ mb: 1 }}>
                  ID Proof
                </FormLabel>

                <RadioGroup
                  row
                  name="identityProofType"
                  value={editedUser?.ID_Proof_Type || ""}
                  onChange={(e) => setEditedUser({ ...editedUser, ID_Proof_Type: e.target.value })}
                >
                  <FormControlLabel value="aadhaar" control={<Radio sx={{ color: "gray" }} />} label="Aadhaar" sx={{ mt: 0.5 }} />
                  <FormControlLabel value="license" control={<Radio sx={{ color: "grey" }} />} label="License" sx={{ mt: 0.5 }} />

                </RadioGroup>

              </FormControl>


              {/* Aadhaar Number Field */}
              {editedUser?.ID_Proof_Type === "aadhaar" && (

                <TextField
                  fullWidth
                  size="small"
                  label="Aadhaar Number"
                  type="text"
                  name="identityProofNumber"
                  value={editedUser?.ID_Proof_Number || ""}
                  onChange={(e) =>
                    setEditedUser({
                      ...editedUser,
                      ID_Proof_Number: e.target.value.replace(/\D/g, "").slice(0, 12),
                    })
                  }
                  error={isSubmitted && (!editedUser?.ID_Proof_Number || editedUser.ID_Proof_Number.length !== 12)}
                  helperText={
                    isSubmitted &&
                    (!editedUser?.ID_Proof_Number
                      ? " "
                      : editedUser.ID_Proof_Number.length !== 12
                        ? " "
                        : "")
                  }
                  inputProps={{ maxLength: 12, pattern: "[0-9]{12}" }}
                  placeholder="Enter Aadhaar Number"
                  sx={{ mt: 2 }}
                  onKeyDown={handleKeyDown}
                />
              )}


              {/* License Number Field */}
              {editedUser?.ID_Proof_Type === "license" && (

                <TextField
                  fullWidth
                  size="small"
                  label="License Number"
                  type="text"
                  name="identityProofNumber"
                  value={editedUser?.ID_Proof_Number || ""}
                  onChange={(e) =>
                    setEditedUser({
                      ...editedUser,
                      ID_Proof_Number: e.target.value
                        .toUpperCase()
                        .replace(/[^A-Z0-9]/g, "")
                        .slice(0, 15),
                    })
                  }
                  error={isSubmitted && !/^[A-Z]{2}\d{13}$/.test(editedUser?.ID_Proof_Number || "")}
                  helperText={
                    isSubmitted &&
                    (!editedUser?.ID_Proof_Number
                      ? " "
                      : !/^[A-Z]{2}\d{13}$/.test(editedUser.ID_Proof_Number)
                        ? " "
                        : "")
                  }
                  inputProps={{ maxLength: 15 }}
                  placeholder="Enter License Number"
                  sx={{ mt: 2 }}
                  onKeyDown={handleKeyDown}

                />

              )}

            </Grid>

            {/* PAN Number Label */}
            <Grid item xs={12} sm={6} >

              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend" sx={{ mb: 1 }}>
                  PAN Card
                </FormLabel>
                <RadioGroup
                  row
                  name="panCard"
                  value={editedUser?.Pan_Card || ""}
                  onChange={(e) => setEditedUser({ ...editedUser, Pan_Card: e.target.value })}


                >
                  <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="No" control={<Radio />} label="No" />

                </RadioGroup>
              </FormControl>

              {/* PAN Number Field (Only if "Yes" is selected) */}
              {editedUser?.Pan_Card === "Yes" && (
                <TextField
                  fullWidth
                  size="small"
                  label="PAN Number"
                  placeholder="Enter PAN Number"
                  name="panCardNumber"
                  value={editedUser?.Pan_Number || ""}
                  onChange={(e) =>
                    setEditedUser({
                      ...editedUser,
                      Pan_Number: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""),
                    })
                  }
                  error={isSubmitted && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(editedUser?.Pan_Number || "")}
                  helperText={
                    isSubmitted &&
                    (!editedUser?.Pan_Number
                      ? " "
                      : !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(editedUser.Pan_Number)
                        ? " "
                        : "")
                  }
                  inputProps={{ maxLength: 10 }}
                  sx={{ mt: 2 }}
                  onKeyDown={handleKeyDown}
                />

              )}

            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl component="fieldset" fullWidth>
                <FormLabel component="legend" sx={{ mb: 1 }} >Marital Status</FormLabel>
                <RadioGroup
                  row
                  name="maritalStatus"
                  value={editedUser?.Marital_Status || ""}
                  onChange={(e) => setEditedUser({ ...editedUser, Marital_Status: e.target.value })}

                >
                  <FormControlLabel value="Single" control={<Radio />} label="Single" />
                  <FormControlLabel value="Married" control={<Radio />} label="Married" />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          <Snackbar open={snackbarOpen} autoHideDuration={10000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
            <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>{snackbarMessage}</Alert></Snackbar>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Cancel</Button>
          {isLoading ? (
            <CircularProgress color="success" />
          ) : (
            <Button onClick={handleSubmit} onKeyDown={handleKeyDown} color="primary" variant="contained">Save</Button>
          )}

        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DataTable;